var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('brace',{staticClass:"kbet-editor",staticStyle:{"height":"90vh"},attrs:{"mode":'json'},on:{"code-change":_vm.onEditorCodeChange,"setHandler":function (h) {
				_vm.editorHandler = h;
			}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }